<template>
  <div :class="isLeft ? 'left-action-bar' : 'top-action-bar'">
    <div class="tools-left" :style="[{width: isLeft ? (item.customW || 180) + 'px' : ''}, getToolBgInfo(item), isLeft ? '' : 'width:100%;padding: 5px;box-sizing: border-box']" v-for="item in todoList" :key="item.i">
      <div class="drag-area" ref="dragArea">
        <div class="change-btn" v-if="item.changeBtn && isLeft">
          <screenBtn :themeColor="themeColor" :isLeft="true" :changeBtn="item.changeBtn" @change-active="changeActiveId($event, item)" :activeId="item.activeId"/>
        </div>
        <div class="tools-container">
          <template v-if="item.type === 'bigsearch'">
            <bigSearch @search-todo="(val) => handleBigSearch(item, val)" :info="item" :themeColor="themeColor" />
          </template>
          <template v-else-if="item.type === 'tool'">
            <div class="drag-left-content" :style="getLeftStyle(item, 'left')">
              <div
                :key="comps.i"
                v-for="comps in leftLayout(item)"
                :style="styleObj(comps)"
              >
                <button-comp
                  v-if="comps.type === 'button' || comps.type === 'button-container'"
                  :info="comps"
                  :applyInfo="applyInfo"
                  :themeColor="themeColor"
                  :tableListInfo="listInfo"
                  :searchCriteria="searchCriteria"
                  :multipleSelection="multipleSelection"
                  :pageId="pageId"
                  :powerData="powerData"
                  :writePower="writePower"
                  :ruledata="ruledata"
                  :screenRef="currentScreenRefList"
                  :otherToolScreenRef="otherScreenRefList"
                  :customData="customParams"
                  :detailListData="listData"
                  :fontStyle="item.fontStyle"
                  :orgList="orgList"
                  :currentOrg="currentOrg"
                  @updateTable="handleButton"
                  @to-nav="$emit('to-nav', $event)"
                  @open-appDialog="$emit('open-appDialog', $event)"
                  @uploadBlock="blockchainChange = $event"
                  @openAppInitiate="$emit('openAppInitiate', $event)"
                  @custom-scene="customScene"
                  @progress-show="isProgressView = $event"
                  @progress-status="progressStatus"
                  @open-dictionary="openDictionary"
                  @change-check-field="$emit('change-check-field', $event)"
                  @field-show="$emit('field-show')"
                  @usual="(val) => usual(val, comps)"
                ></button-comp>
                <search-comp
                  v-else-if="comps.type === 'search'"
                  :themeColor="themeColor"
                  :fontStyle="item.fontStyle"
                  :applyInfo="applyInfo"
                  @search-todo="handleSearch($event, comps)"
                  :info="comps"
                ></search-comp>
                <screen-comp
                  v-else-if="comps.type === 'screen'"
                  ref="screenRef"
                  :screenRef="$refs.screenRef"
                  :themeColor="themeColor"
                  :fontStyle="item.fontStyle"
                  :applyInfo="applyInfo"
                  :powerData="powerData"
                  :totalParams="totalParams"
                  :isLeft="isLeft"
                  :pageId="pageId"
                  :addConfig="addConfig"
                  :noChangeScreenId="noChangeScreenId"
                  :isInDetailed="isInDetailed"
                  @change-screen-id="$emit('change-screen-id', $event)"
                  @change-new-screen="screenChange"
                  @close-loading="loading = false"
                  :dataInfo="comps"
                ></screen-comp>
              </div>
            </div>
            <div class="drag-right-content" :style="getLeftStyle(item, 'right')">
              <div
                :key="comps.i"
                v-for="comps in rightLayout(item)"
                :style="styleObj(comps)"
              >
                <button-comp
                  v-if="comps.type === 'button' || comps.type === 'button-container'"
                  :info="comps"
                  :applyInfo="applyInfo"
                  :themeColor="themeColor"
                  :tableListInfo="listInfo"
                  :searchCriteria="searchCriteria"
                  :multipleSelection="multipleSelection"
                  :pageId="pageId"
                  :powerData="powerData"
                  :writePower="writePower"
                  :ruledata="ruledata"
                  :screenRef="currentScreenRefList"
                  :otherToolScreenRef="otherScreenRefList"
                  :customData="customParams"
                  :detailListData="listData"
                  :fontStyle="item.fontStyle"
                  :orgList="orgList"
                  :currentOrg="currentOrg"
                  @updateTable="handleButton"
                  @to-nav="$emit('to-nav', $event)"
                  @open-appDialog="$emit('open-appDialog', $event)"
                  @uploadBlock="blockchainChange = $event"
                  @openAppInitiate="$emit('openAppInitiate', $event)"
                  @custom-scene="customScene"
                  @progress-show="isProgressView = $event"
                  @progress-status="progressStatus"
                  @open-dictionary="openDictionary"
                  @usual="(val) => usual(val, comps)"
                  @change-check-field="$emit('change-check-field', $event)"
                  @field-show="$emit('field-show')"
                ></button-comp>
                <search-comp
                  v-else-if="comps.type === 'search'"
                  :themeColor="themeColor"
                  :applyInfo="applyInfo"
                  :fontStyle="item.fontStyle"
                  @search-todo="handleSearch($event, comps)"
                  :info="comps"
                ></search-comp>
                <screen-comp
                  v-else-if="comps.type === 'screen'"
                  ref="screenRef"
                  :screenRef="$refs.screenRef"
                  :themeColor="themeColor"
                  :applyInfo="applyInfo"
                  :powerData="powerData"
                  :totalParams="totalParams"
                  :pageId="pageId"
                  :isLeft="isLeft"
                  :noChangeScreenId="noChangeScreenId"
                  :fontStyle="item.fontStyle"
                  :addConfig="addConfig"
                  :isInDetailed="isInDetailed"
                  @change-screen-id="$emit('change-screen-id', $event)"
                  @change-new-screen="screenChange"
                  @close-loading="loading = false"
                  :dataInfo="comps"
                ></screen-comp>
              </div>
            </div>
          </template>
        </div>
        <div class="change-btn" v-if="item.changeBtn && !isLeft">
          <screenBtn :themeColor="themeColor" :changeBtn="item.changeBtn" @change-active="changeActiveId($event, item)" :activeId="item.activeId" />
        </div>
      </div>
    </div>
    <exportProgress v-model:isView="isProgressView" :isClose="isProgress" @closed="isProgress = false" />
    <upOption ref="upOption"></upOption>
  </div>
</template>

<script>
import { getToolBgInfo } from '@/components/schoolInstrument/mixins/utils'
import buttonComp from '@/components/schoolInstrument/component/mutual/component/button'
import searchComp from '@/components/schoolInstrument/component/mutual/component/search'
import bigSearch from '@/components/schoolInstrument/component/mutual/component/search/bigSearch'
import screenComp from '@/components/schoolInstrument/component/mutual/component/screen'
import screenBtn from '@/components/schoolInstrument/component/mutual/component/button/screenBtn.vue'
import exportProgress from '@/components/common/exportProgress'
import upOption from '@/components/schoolInstrument/mixins/upOption.vue'
import { getScreenRectInfo, isAdaption } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { cloneDeep } from 'lodash'
export default {
  name: 'actionBar',
  components:{
    buttonComp,
    searchComp,
    screenComp,
    screenBtn,
    exportProgress,
    upOption,
    bigSearch
  },
  data(){
    return {
      blockchainChange: false,
      loading: false,
      isProgress: false,
      isProgressView: false,
      totalParams: {},
      multipleSelection: [],
      currentScreenRefList: []
    }
  },
  props:{
    todoList:{
      type: Array,
      default: ()=>([])
    },
    pageId: {
      type: String,
      default: '1'
    },
    isLeft:{
      type: Boolean,
      default: false,
    },
    applyInfo:{
      type: Object,
      default: ()=>({})
    },
    listInfo:{
      type: Object,
      default: ()=>({})
    },
    searchCriteria:{
      type: Object,
      default: ()=>({})
    },
    powerData:{
      type: Object,
      default: ()=>({})
    },
    writePower:{
      type: [Object, Boolean],
      default: ()=>({})
    },
    ruledata:{
      type: Object,
      default: ()=>({})
    },
    toolList:{
      type: Object,
      default: ()=>({})
    },
    currentOrg:{
      type: Object,
      default: ()=>({})
    },
    customParams:{
      type: Array,
      default: ()=>([])
    },
    themeColor:{
      type: String,
      default: ''
    },
    noChangeScreenId:{
      type: Number,
      default: -1
    },
    listData: {
      type: Array,
      default: ()=>([])
    },
    addConfig: {
      type: Object,
      default: ()=>({formdata: {}, property: []})
    },
    // 是否是门户明细表篇
    isInDetailed: {
      type: Boolean,
      default: false
    },
    // 是否是门户明细表篇
    orgList: {
      type: Array,
      default: ()=>([])
    }
  },
  computed: {
    otherScreenRefList () {
      const ref = []
      const otherTooLRef = this.toolList
      if (otherTooLRef && otherTooLRef.$refs && otherTooLRef.$refs.screenRef) {
        ref.push(...otherTooLRef.$refs.screenRef)
      }
      return ref
    }
  },
  watch: {
    todoList: {
      immediate: true, // 立即执行一次，处理初始情况
      handler(newVal) {
        // 确保有数据且 DOM 已更新
        if (newVal && newVal.length > 0) {
          this.$nextTick(() => {
            if (this.$refs.screenRef) {
              this.currentScreenRefList = this.$refs.screenRef
            }
          })
        }
      }
    }
  },
  methods: {
    usual (val, config) {
      this.$emit('usual', {config: config, type: val})
    },
    getLeftStyle (item, type = 'left') {
      let li = this.leftLayout(item)
      if (type === 'right') {
        li = this.rightLayout(item)
      }
      if (this.isLeft) {
        return { flex: isAdaption(li) ? '1' : '', height: isAdaption(li) ? '0px' : '' }
      } else {
        return { flex: isAdaption(li) ? '1' : '' }
      }
    },
    changeActiveId (id, item) {
      const prevId = item.activeId
      const list = item[prevId]
      item.activeId = id
      this.$emit('changeActiveId', list)
    },
    styleObj (comps) {
      const top = { width: getScreenRectInfo(comps, 'customW') }
      const left = {
        height: getScreenRectInfo(comps, 'customH'),
        padding: comps.type === 'screen' ? '' : '0 10px',
        width: '100%',
        overflowY: comps.type === 'screen' ? 'auto' : '',
      }
      return this.isLeft ? left : top
    },
    getToolBgInfo(item){
      let toolfllStyle = {}
      if (item.bgInfo) {
        toolfllStyle = item.bgInfo
      }
      return getToolBgInfo(toolfllStyle)
    },
    leftLayout (item) {
      const value = this.getCorrectInfo(item)
      return value.filter(c => c.isLeft === true || c.isLeft === undefined)
    },
    rightLayout (item) {
      const value = this.getCorrectInfo(item)
      return value.filter(c => c.isLeft === false)
    },
    getCorrectInfo (item) {
      const activeId = item.activeId
      let list = []
      if (!activeId) {
        list = item.info
      } else {
        list = item[activeId] || []
      }
      return list
    },
    handleButton(value) {
      let query = {}
      if (value && value.query) {
        query = typeof value.query === 'string' ? JSON.parse(value.query) : value.query
      }
      this.$emit('update-list', query)
    },
    customScene(val){
      const { url, query, open, popUps } = val
      const obj = {
        2: 'dialog',
        3: 'new',
        4: 'old',
        5: 'rightdia'
      }
      const dialogInfo = {
        isVisible: true,
        dialogName: query.name,
        dialogWidth: popUps.w + 'px',
        dialogHeight: popUps.h + 'px',
        openType: obj[open],
        dialogUrl: url,
        customSize: popUps.customSize,
        diaSize: popUps.diaSize,
      }
      this.$emit('open-appDialog', dialogInfo)
    },
    openDictionary(info){
      const val = cloneDeep(info)
      if (val.schoolId) delete val.schoolId;
      let str = typeof val.options === 'string' ? JSON.parse(val.options) : val.options
      str = str.join(',')
      val.options = str.replace(/,/g, '\n')
      this.$refs.upOption.viewDialog({ title: '编辑选项' }, val);
    },
    screenChange(value){
      this.$emit('screenChange', value)
    },
    progressStatus(){
      const flag = typeof status === 'boolean'
      this.isProgress = true
      if (flag) {
        this.$message.success('导出成功')
      } else {
        this.$message.success('导出失败')
      }
    },
    handleSearch(value, item){
      this.$emit('handeSearch', value, item)
    },
    handleBigSearch (item, value) {
      this.$emit('handleBigSearch', { config: item, value })
    }
  },
}
</script>

<style lang='scss' scoped>
.top-action-bar {
  .drag-list {
    position: relative;
    height: 40px;
    &:hover {
      .tool {
        display: block;
      }
    }
  }
  .drag-area {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    padding: 5px;
    box-sizing: border-box;
    .tools-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      .drag-left-content {
        display: flex;
        height: 30px;
      }

      .drag-right-content {
        display: flex;
        height: 30px;
        justify-content: flex-end;
      }
    }
  }
}
.tool {
  position: absolute;
  display: none;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 98;
  background: rgba(0, 0, 0, 0.5);

  .toolArea {
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    justify-content: center;

    .editTools {
      // color: #fff;
      margin-right: 10px;
    }
    .changeTools {
      // color: #fff;
      margin-left: 10px;
    }
    .WSicon-fwbA {
      font-size: 20px;
    }
    .iconfont, .WSiconfont {
      color: #fff;

      &:hover {
        color: #4e86ff;
      }
    }
  }
}
.left-action-bar {
  height: 100%;
  width: 100%;
  ::v-deep .tools-left {
    width: 180px;
    margin-right: 10px;
    height: 100%;
    position: relative;
    z-index: 1001;
    &:hover {
      .tool {
        display: block;
      }
    }
    .left-drag-content {
      .handle-mr {
        display: block !important;
      }
    }
    .drag-area {
      box-sizing: border-box;
      display:flex;
      flex-direction: column;
      padding: 10px 0;
      width: 100%;
      height: 100%;
      .tools-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        flex: 1;
        .drag-left-content,.drag-right-content {
          display: flex;
          flex-wrap: wrap;
          height: initial;
          width: 100%;
          .button-reveal {
            display: flex;
            align-items: center;
            .btn-one {
              width: 100%;
              height: 30px;
            }
            .btn-two {
              justify-content: flex-start;
            }
          }
          .detail {
            margin-right: 0 !important;
            .el-select {
              min-width: initial;
            }
          }
        }
      }
    }
  }
}

.tools-left {
  background-color: #fff;
}
</style>